export const serviceOptions=[
  'DJ',
  'MC',
  'Dancers',
  'Live Musician',
  'Photo Booth',
  'Uplighting',
  'Gobo Monogram',
  'LED DJ Booth',
  'LED Screen',
  'Projector and screen',
  'Karaoke',
  'Silent DISCO',
  'Laser Light',
  'Special Effects',
  'Arcade Machines',
  'Pipe and Drape',
  'Stage',
  'Lighting',
  'Dance Floor',
  'Photographer',
  'Videographer',
  'Event Planner',
  'Other'
];